import { useEffect } from "react";
import { SetURLSearchParams } from "react-router-dom";

import type { SidebarTab } from "@/components/SidebarSearchLayout/sidebar-tab-context";
import { REQUEST_LOGS_DRAWER_INTENT } from "@/utils/requestLogUrlParams";

type SidebarTabSetter = (tab: SidebarTab) => void;

export const useReviewLogsDrawerIntentParams = ({
  isWorkspaceAnalyticsPage,
  shouldOpenDrawer = true,
  searchParams,
  setSearchParams,
  setIsSecondarySidebarOpen,
  setActiveSidebarTab,
  setShowReviewLogsDrawerOnAnalytics,
}: {
  isWorkspaceAnalyticsPage: boolean;
  shouldOpenDrawer?: boolean;
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
  setIsSecondarySidebarOpen: (open: boolean) => void;
  setActiveSidebarTab?: SidebarTabSetter;
  setShowReviewLogsDrawerOnAnalytics?: (show: boolean) => void;
}) => {
  useEffect(() => {
    if (searchParams.get(REQUEST_LOGS_DRAWER_INTENT) !== "1") {
      return;
    }

    if (!shouldOpenDrawer) {
      const next = new URLSearchParams(searchParams);
      next.delete(REQUEST_LOGS_DRAWER_INTENT);
      setSearchParams(next, { replace: true });
      return;
    }

    if (isWorkspaceAnalyticsPage) {
      setShowReviewLogsDrawerOnAnalytics?.(true);
    }
    setIsSecondarySidebarOpen(true);
    setActiveSidebarTab?.("Requests");

    const next = new URLSearchParams(searchParams);
    next.delete(REQUEST_LOGS_DRAWER_INTENT);
    setSearchParams(next, { replace: true });
  }, [
    isWorkspaceAnalyticsPage,
    shouldOpenDrawer,
    searchParams,
    setSearchParams,
    setIsSecondarySidebarOpen,
    setActiveSidebarTab,
    setShowReviewLogsDrawerOnAnalytics,
  ]);
};
